import { Dialog, Transition } from "@headlessui/react"
import { XIcon } from "@heroicons/react/outline"
import React, { Fragment } from "react"

export default function VideoModal({ onClose, sourceUrl }) {
  return (
    <Transition.Root show as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-50 inset-0 overflow-y-auto"
        onClose={onClose}
      >
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-900/80 bg-opacity-90 transition-opacity" />
          </Transition.Child>
          <button
            className="absolute right-2 top-2"
            onClick={onClose}
            type="button"
          >
            <XIcon className="h-8 w-8 text-white" aria-hidden="true" />
          </button>
          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="w-10/12 relative inline-block align-bottom bg-white rounded-lg p-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6">
              <div>
                <video
                  className="w-full h-video-modal-s sm:h-video-modal-l"
                  width="560"
                  height="315"
                  src={sourceUrl}
                  title="Video player"
                  controls
                >
                  <source src={sourceUrl} type="video/mp4" />
                  <source src={sourceUrl} type="video/ogg" />
                  <source src={sourceUrl} type="video/webm" />
                  <source src={sourceUrl} type="video/ogg" />
                  <track kind="captions" />
                </video>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
